import Page, { BlocksPipes, Galleries } from '../../../../common/types/api/page'
import { WidgetTypes } from '../../../../common/types/api/report'
import { WidgetPage } from '../types'

export function getWidgetPage(id: number, type: WidgetTypes, page: Page): WidgetPage {
    const { blocksHtml, blocksPipes = [], galleries } = page

    switch (type) {
        case WidgetTypes.PIPES:
            return {
                type,
                config: blocksPipes.find(block => block.id === id) as BlocksPipes
            }
        case WidgetTypes.HTML:
            return {
                type,
                config: blocksHtml.find(block => block.id === id) as BlocksPipes
            }
        case WidgetTypes.GALLERY:
            return {
                type,
                config: galleries.find(block => block.id === id) as Galleries
            }
    }
}
